module.exports = __webpack_public_path__ + "img/loading.6e5d6096.gif";